import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import ToolbarIconButton from 'components/consumer/ToolbarIconButton';
import Link from 'components/consumer/Link';
import useUserData from 'data-hooks/useUserData';
import DropdownItem from './DropdownItem';

const HeaderToolbarDropdown = ({
  icon,
  title = '',
  dropdownItems = [],
  children,
  iconClassName = '',
  'data-xc': dataXc = '',
}) => {
  const { isLoggedIn } = useUserData();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownContainerRef = useRef(null);

  const onDropdownButtonClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClickOutside = useCallback(event => {
    if (
      dropdownContainerRef.current &&
      !dropdownContainerRef.current.contains(event.target)
    ) {
      setIsDropdownOpen(false);
    }
  }, []);

  useEffect(() => {
    if (!isDropdownOpen) return undefined;

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen, handleClickOutside]);

  return (
    <div ref={dropdownContainerRef}>
      <ToolbarIconButton
        data-xc={dataXc}
        icon={icon}
        onClick={onDropdownButtonClick}
        title={title}
        className={`max-[1023px]:hidden ${iconClassName}`}
      />
      {isDropdownOpen && (
        <div className="absolute min-w-[8rem] top-12 right-0 bg-white border border-gray-light5">
          {children ||
            dropdownItems?.map((item, index) =>
              item?.link ? (
                <Link
                  to={
                    isLoggedIn && item?.loggedInLink
                      ? item?.loggedInLink
                      : item?.link
                  }
                  key={item?.text}
                  className="background:none] border-0 focus-visible:outline-offset-4 hover:text-brand hover:underline"
                >
                  <DropdownItem
                    isLoggedIn={isLoggedIn}
                    item={item}
                    index={index}
                  />
                </Link>
              ) : item?.onClick ? (
                <div
                  onClick={item?.onClick}
                  role="button"
                  tabIndex={0}
                  key={item?.text}
                >
                  <DropdownItem item={item} index={index} />
                </div>
              ) : (
                <DropdownItem item={item} index={index} key={item?.text} />
              )
            )}
        </div>
      )}
    </div>
  );
};

HeaderToolbarDropdown.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
  dropdownItems: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  iconClassName: PropTypes.string,
  'data-xc': PropTypes.string,
};

export default HeaderToolbarDropdown;
